// extracted by mini-css-extract-plugin
export default {"carousel":"carousel--fhyr9","slide":"slide--fhyr9","slider":"slider--fhyr9"};